import {NgModule} from '@angular/core';
import {SharedModule} from "../../shared/shared.module";
import {NgOptimizedImage} from "@angular/common";
import {ChartModule} from 'primeng/chart';
import {AnimalsModule} from '../animals/animals.module';
import {DashboardComponent} from './dashboard.component';
import {DataViewModule} from "primeng/dataview";
import {ChipModule} from "primeng/chip";
import {TagModule} from "primeng/tag";
import {RouterModule} from "@angular/router";
import {MessageModule} from "primeng/message";
import {DashboardSearchComponent} from './search/dashboard-search.component';
import {DashboardDueTreatmentsComponent} from './medical/dashboard-due-treatments.component';
import {DashboardMedicalSearchComponent} from './medical/dashboard-medical-search.component';

@NgModule({
  imports: [
    SharedModule,
    NgOptimizedImage,
    ChartModule,
    AnimalsModule,
    DataViewModule,
    ChipModule,
    TagModule,
    MessageModule,
    RouterModule,
  ],
  declarations: [
    DashboardComponent,
    DashboardSearchComponent,
    DashboardDueTreatmentsComponent,
    DashboardMedicalSearchComponent,
  ],
  exports: [],
  providers: []
})
export class DashboardModule {
}
